import { useEffect, useState } from 'react';
import QuickBookingForm from './QuickBookingForm';

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: 'https://public.readdy.ai/ai/img_res/48055b05f8dfa4381bcf24b4086fd3a4.jpg',
      title: 'رحلة فاخرة',
      subtitle: 'إلى الأماكن المقدسة',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=luxurious%20black%20SUV%20parked%20in%20front%20of%20grand%20hotel%20entrance%20at%20dusk%20with%20elegant%20lighting%2C%20premium%20hospitality%20photography%2C%20sophisticated%20arrival%20scene%2C%20warm%20ambient%20glow%2C%20professional%20automotive%20shot%2C%20upscale%20travel%20experience&width=1920&height=1080&seq=hero-slide-002&orientation=landscape',
      title: 'خدمة متميزة',
      subtitle: 'على مدار الساعة',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=premium%20black%20luxury%20car%20interior%20with%20elegant%20leather%20seats%20and%20ambient%20lighting%20at%20night%2C%20sophisticated%20automotive%20photography%2C%20executive%20comfort%2C%20refined%20details%2C%20warm%20golden%20accents%2C%20professional%20product%20shot&width=1920&height=1080&seq=hero-slide-003&orientation=landscape',
      title: 'راحة وأمان',
      subtitle: 'في كل رحلة',
    },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [slides.length]);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <section className="relative w-full min-h-screen overflow-hidden">
      {/* Slides */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          {/* Background Image */}
          <div className="absolute inset-0 w-full h-full">
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover object-top"
            />
          </div>

          {/* Overlay */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
        </div>
      ))}

      {/* Content */}
      <div className="relative z-10 min-h-screen flex items-center py-20 lg:py-0">
        <div className="container mx-auto px-6 lg:px-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Side - Text Content */}
            <div className="text-white text-center lg:text-right">
              <div className="mb-6">
                <div className="inline-block bg-gold/20 backdrop-blur-sm px-6 py-3 rounded-full mb-6">
                  <span className="font-cairo font-semibold text-gold text-sm">
                    خدمات نقل فاخرة
                  </span>
                </div>
              </div>

              <h1 className="font-almarai font-bold text-5xl lg:text-7xl mb-6 leading-tight">
                {slides[currentSlide].title}
                <br />
                <span className="text-gold">{slides[currentSlide].subtitle}</span>
              </h1>

              <p className="font-cairo text-xl lg:text-2xl mb-8 text-white/90 max-w-2xl mx-auto lg:mx-0">
                نوفر لكم أفخم السيارات مع سائقين محترفين لرحلة مريحة وآمنة
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                <a
                  href="#cars-gallery"
                  className="bg-gold hover:bg-gold/90 text-luxury-black font-cairo font-bold px-8 py-4 rounded-full transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg"
                >
                  اختر سيارتك
                </a>
                <a
                  href="#services"
                  className="bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border-2 border-white/30 font-cairo font-semibold px-8 py-4 rounded-full transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
                >
                  خدماتنا
                </a>
              </div>
            </div>

            {/* Right Side - Booking Form */}
            <div className="hidden lg:block">
              <QuickBookingForm />
            </div>
          </div>
        </div>
      </div>

      {/* Slide Indicators */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 flex gap-3">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
              index === currentSlide
                ? 'bg-gold w-12'
                : 'bg-white/50 hover:bg-white/80'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>

      {/* Mobile Booking Form - Separate Section Below Hero */}
      <div className="lg:hidden relative z-20 bg-gradient-to-b from-luxury-black to-gray-900 py-12 px-6">
        <QuickBookingForm />
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 right-8 z-20 hidden lg:block">
        <div className="flex flex-col items-center gap-2 text-white/70 animate-bounce">
          <span className="font-cairo text-sm">اكتشف المزيد</span>
          <i className="ri-arrow-down-line text-2xl"></i>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
